export const HUBSPOT_PORTAL_ID = "139782829";
export const HUBSPOT_REGION = "eu1";

export const HUBSPOT_SUBMIT_URL = (formId: string) =>
  `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${formId}`;

export const FORM_IDS = {
  ingredientRequest: "94fecb05-bea0-4448-9ca1-71d0eaa9954c",
  tagsRequest: "94fecb05-bea0-4448-9ca1-71d0eaa9954c",
  referral: "26cd8cc7-2541-489d-b36d-dd7ab3804e0a",
  requestLocation: "94fecb05-bea0-4448-9ca1-71d0eaa9954c",
} as const;
